// Australian States and Territories
export const australianStates = [
  { code: "NSW", name: "New South Wales", nameKo: "뉴사우스웨일스" },
  { code: "VIC", name: "Victoria", nameKo: "빅토리아" },
  { code: "QLD", name: "Queensland", nameKo: "퀸즐랜드" },
  { code: "SA", name: "South Australia", nameKo: "남호주" },
  { code: "WA", name: "Western Australia", nameKo: "서호주" },
  { code: "TAS", name: "Tasmania", nameKo: "태즈메이니아" },
  { code: "NT", name: "Northern Territory", nameKo: "노던 준주" },
  { code: "ACT", name: "Australian Capital Territory", nameKo: "수도 준주" },
  { code: "ALL", name: "All Australia", nameKo: "호주 전체" },
] as const;

export type StateCode = typeof australianStates[number]["code"];

export function getStateName(code: StateCode, locale: "en" | "ko" = "en"): string {
  const state = australianStates.find(s => s.code === code);
  return state ? (locale === "ko" ? state.nameKo : state.name) : code;
}

export function isValidStateCode(code: string): code is StateCode {
  return australianStates.some(s => s.code === code);
}
